

import moment from 'moment';

const days = {
    'fc-sun': 1,
    'fc-mon': 2,
    'fc-tue': 3,
    'fc-wed': 4,
    'fc-thu': 5,
    'fc-fri': 6,
    'fc-sat': 7
};

function defineDayName(element) {
    return element
        .attr('class')
        .split(' ')
        .filter(function(dayName) {
            return _.has(days, dayName);
        })[0];
}

function getWorkingDays(location) {
    const workingDays = location ?
        location.get('workingDays') : app.company.get('workingDays');

    return workingDays ? workingDays : [0, 1, 1, 1, 1, 1, 0];
}

function getDayWorkLoad(cell, location) {
    const dayName = defineDayName(cell);
    const workingDays = getWorkingDays(location);
    const dayNumber = days[dayName] && days[dayName] - 1;

    return workingDays[dayNumber];
}

var states = {
    '01': 'Johor',
    '02': 'Kedah',
    '03': 'Kelantan',
    '14': 'Kuala Lumpur',
    '15': 'Labuan',
    '04': 'Malacca',
    '05': 'Negeri Sembilan',
    '06': 'Pahang',
    '07': 'Penang',
    '08': 'Perak',
    '09': 'Perlis',
    '16': 'Putrajaya',
    '12': 'Sabah',
    '13': 'Sarawak',
    '10': 'Selangor',
    '11': 'Terengganu'
};

function renderHoliday(_holidays, date, cell) {
    const formattedHolidays = _holidays.filter(x => x.get('enabled') === true 
        || x.get('enabled') === undefined).map(holiday => ({
        date: moment.utc(holiday.get('date')).toDate(),
        isNational: holiday.get('isNational'),
        title: holiday.get('title'),
        description: holiday.get('description'),
        include: holiday.get('include'),
        exclude: holiday.get('exclude'),
        custom: !!holiday.get('company')
    }));

    const holidays = formattedHolidays.filter(
        holiday => moment(holiday.date).isSame(date, 'day')
    ).sort(holiday => holiday.isNational ? -1 : 1);

    if (!holidays.length) {
        return;
    }

    var $holidays = [];

    holidays.forEach(function(holiday, index) {
        var title = holiday.title + '. ';
        title += '<br/><i>';
        if (holiday.isNational) {
            title += 'National. ';
            $(cell).addClass('fc-national-holiday');
        } else {
            $(cell).addClass('fc-holiday');
        }
        if (!_.isEmpty(holiday.include)) {
            title += _.map(holiday.include, function(code) {
                return states[code];
            }).join(', ') + ' only.';
        }
        if (!_.isEmpty(holiday.exclude)) {
            title += 'All states except ' + _.map(holiday.exclude,
                function(code) {
                    return states[code];
                }).join(', ') + '.';
        }
        title += '</i>';

        var $holiday = $('<div>').text(holiday.title).tooltip({
            title: title,
            placement: 'top',
            trigger: 'hover',
            html: true,
            container: 'body'
        });
        if (holidays.length > 1) {
            $holiday.addClass('font-small');
        }
        $holidays.push($holiday);
        if (index !== holidays.length - 1) {
            $holidays.push('<hr/>');
        }
    });

    $(cell).append($holidays);
}

module.exports = {
    getDayWorkLoad:   getDayWorkLoad,
    states:           states,
    renderHoliday:    renderHoliday
};



// WEBPACK FOOTER //
// ./app/helpers/calendar.js